import { render } from "./InsuranceClaimPreviewModal.vue?vue&type=template&id=067b6ab5&scoped=true"
import script from "./InsuranceClaimPreviewModal.vue?vue&type=script&lang=js"
export * from "./InsuranceClaimPreviewModal.vue?vue&type=script&lang=js"

import "./InsuranceClaimPreviewModal.vue?vue&type=style&index=0&id=067b6ab5&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067b6ab5"]])

export default __exports__